module.exports = __webpack_public_path__ + "09592ee30ce738eb986fcc732480e4b2.jpg";